module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-04-27 at 21.26.55 (1).a91ff709.jpeg";